import React from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';

function ForesightError() {
  return (
    <Alert severity="error">
      <AlertTitle>Error</AlertTitle>
      {'Cannot generate Foresight'}
    </Alert>
  );
}

export { ForesightError };
